import { render, staticRenderFns } from "./positionJob.vue?vue&type=template&id=9625da3e&scoped=true"
import script from "./positionJob.vue?vue&type=script&lang=js"
export * from "./positionJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9625da3e",
  null
  
)

export default component.exports